import { useState } from "react";
import { ListGroup, Button, Modal } from "react-bootstrap";
//Api 
import { PosIntegrationFetchAPI } from "../../../api/PosIntegrations";
import { RenderIf } from "../../utils/RenderIf";
import './IntegrationsList.css';
//Function to list the integrations of the business
const IntegrationsList = ({ business, branchoffice, token }) => {
    //States
    const [showModal, setShowModal] = useState(false);
    const [selectedIntegration, setSelectedIntegration] = useState({
        name: null,
        pos_integration_id: null
    });
    const [configParams, setConfigParams] = useState([]);
    // Handler for configuration button click
    const handleConfigClick = (integration) => {
        console.log("Configuring integration:", integration);
        setSelectedIntegration(integration);
        setShowModal(true);
        getConfigParams(integration);
    };

    //Handler to get the configuration params of the selected integration
    const getConfigParams = async (integration) => {
        try {
            const configParams = await PosIntegrationFetchAPI.getPosIntegrationParamsByBranch(integration.pos_integration_id, branchoffice.id, token);
            setConfigParams(configParams.data.params_values);
        } catch (err) {
            console.error("Error fetching configuration params:", err);
        }
    };

    //Config params to manage
    const handleConfigChange = (paramId, value) => {
        setConfigParams((prevParams) =>
            prevParams.map((param) =>
                param.pos_integration_param_value_id === paramId ? { ...param, value } : param
            )
        );
    };

    //Function to manage the name of the config param
    const getConfigParamName = (param) => {
        switch (param.param_name) {
            case "auto_accept_order":
                return "Auto aceptar pedido";
            case "smartpay_pedidosya_default_machine_code":
                return "Código de máquina predeterminado para manejar PedidosYa";
            default:
                return param.param_name;
        }
    };

    //Function to update the configuration params
    const updateConfigParams = async () => {
        try {
            let updateJustEditable = configParams.filter(param => param.editable === 1);
            await PosIntegrationFetchAPI.updatePosIntegrationParams(selectedIntegration.pos_integration_id, branchoffice.id, token, updateJustEditable);
            setShowModal(false);
        } catch (err) {
            console.error("Error updating configuration params:", err);
        }
    };

    return (
        <div className="sp-int">
            <div className="sp-int__list">
                {business.posIntegrations.map((integration, index) => (
                    <div className="sp-int__item" key={index}>
                        <div className="sp-int__name">
                            <span className="sp-int__ic"><i className="uil uil-plug"></i></span>
                            {integration.name}
                        </div>
                        <button className="sp-cfg__btn sp-cfg__btn--primary" onClick={() => handleConfigClick(integration)}>
                            <i className="uil uil-setting"></i> Configurar
                        </button>
                    </div>
                ))}
            </div>

            {/** Modal for integration configuration */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                backdrop="static"
                keyboard={false}
               size="sm-down"
               centered
               
            >
                <Modal.Body className="sp-cfgmini rounded-5">
                    <div className="sp-cfgmini__head">
                        {/* <div className="sp-cfg__badge sp-cfg__badge--sm"><i className="uil uil-plug"></i></div> */}
                        <h5 className="sp-cfgmini__title">Configurar Integración</h5>
                        <button className="sp-cfg__x" type="button" aria-label="Cerrar" onClick={() => setShowModal(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    <p className="sp-int__sub">Configurando integración para: <strong>{selectedIntegration?.name || "Sin nombre"}</strong></p>

                    {/** We list the configuration parameters */}
                    <div className="sp-int__params">
                        {configParams.map((param) => (
                            <RenderIf isTrue={param.editable === 1} key={"integration-id" + param.pos_integration_param_value_id}>
                                <div className="sp-cfg__field">
                                    <label className="sp-cfg__label">{getConfigParamName(param)}</label>
                                    <input
                                        type="text"
                                        className="sp-cfg__input"
                                        value={param.value}
                                        onChange={(e) => handleConfigChange(param.pos_integration_param_value_id, e.target.value)}
                                    />
                                </div>
                            </RenderIf>
                        ))}
                    </div>

                    <div className="sp-cfgmini__acts sp-cfgmini__acts--split">
                        <button className="sp-cfg__btn sp-cfg__btn--ghost" onClick={() => setShowModal(false)}>Cancelar</button>
                        <button className="sp-cfg__btn sp-cfg__btn--primary" onClick={updateConfigParams}>Guardar Cambios</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}



export default IntegrationsList;
